import { cn } from "@/shared/utils/cn";
import Center from "../Base/Center";
import { useTranslation } from "react-i18next";

const SoldOut = () => {
  const { t } = useTranslation();
  return (
    <Center className={cn("w-32 h-12 mx-6 rounded-4xl bg-error/70")}>
      <span className="font-bold text-2xl opacity-85">{t("soldOut")}</span>
    </Center>
  );
};

export default SoldOut;
